module.exports = __webpack_public_path__ + "img/dd.d7701c3a.svg";